document.addEventListener("DOMContentLoaded", function() {
    var zapietDeliveryValidatorPostalCode = document.querySelector('#zapiet-delivery-validator__postal_code');
    var zapietDeliveryValidatorSubmit = document.querySelector('.zapiet-delivery-validator__submit');


    if(zapietDeliveryValidatorSubmit) {
        zapietDeliveryValidatorSubmit.addEventListener('click', function() {
            var valuePostalCode = zapietDeliveryValidatorPostalCode.value;
            localStorage.setItem('postal-code', valuePostalCode);
        });
    }
});